import script from "./title.vue?vue&type=script&setup=true&lang=js"
export * from "./title.vue?vue&type=script&setup=true&lang=js"

import "./title.vue?vue&type=style&index=0&id=cee42aa0&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cee42aa0"]])

export default __exports__